import { SubscriptionHelper } from '@/Domain/helper/Subscription.helper';
import { useGetSubscription } from '@/Domain/hooks/Subscription/useGetSubscription.hook';
import { useGetSubscriptionPlans } from '@/Domain/hooks/Subscription/useGetSubscriptionPlans.hook';
import { SubscriptionPage } from '@/UI/Subscription/Subscription.page';
import { SubscriptionSkeleton } from '@/UI/Subscription/Subscription.skeleton';

export const SubscriptionLoader = () => {
  const subscriptionQuery = useGetSubscription();
  const subscriptionPlansQuery = useGetSubscriptionPlans();

  if (subscriptionQuery.isLoading || subscriptionPlansQuery.isLoading) {
    return <SubscriptionSkeleton />;
  }

  const currentPlan = subscriptionQuery.data!.current_plan;

  return (
    <SubscriptionPage
      currentPlan={{
        ...currentPlan,
        tier: SubscriptionHelper.getBillingDisplayTier(currentPlan.tier),
      }}
      subscription={subscriptionQuery.data!.subscription}
      plans={subscriptionPlansQuery.data!.products}
      pricing={subscriptionPlansQuery.data!.subscriptions}
    />
  );
};
